export default __webpack_public_path__ + "static/media/caret.ecacf5e7.svg";